export class ButtonTranslationKeys {
  static readonly Yes = 'BUTTON.YES'
  static readonly No = 'BUTTON.NO'
  static readonly Cancel = 'BUTTON.CANCEL'
  static readonly Update = "BUTTON.UPDATE"
  static readonly Ok = "BUTTON.OK"
}

export class AuthorizationTranslationKeys {
  static readonly CurrentPassword = 'AUTHORIZATION.CURRENT_PASSWORD'
  static readonly CurrentPasswordPlaceHolder = 'AUTHORIZATION.CURRENT_PASSWORD'
  static readonly CurrentPasswordRequiredError = 'AUTHORIZATION.CURRENT_PASSWORD_REQUIRED'
  static readonly NewPassword = 'AUTHORIZATION.PASSWORD_NEW'
  static readonly NewPasswordPlaceHolder = 'AUTHORIZATION.PASSWORD_NEW'
  static readonly NewPasswordRequiredError = 'AUTHORIZATION.PASSWORD_NEW_IS_REQUIRED'
  static readonly NewPasswordFormatError = "AUTHORIZATION.PASSWORD_RULE"
  static readonly ConfirmPassword = 'AUTHORIZATION.PASSWORD_CONFIRMATION'
  static readonly ConfirmPasswordPlaceHolder = 'AUTHORIZATION.PASSWORD_CONFIRMATION'
  static readonly ConfirmPasswordRequiredError = 'AUTHORIZATION.PASSWORD_CONFIRMATION_IS_REQUIRED'
  static readonly Save = 'AUTHORIZATION.SAVE'
  static readonly ConfirmPasswordNotMatchingError = 'AUTHORIZATION.PASSWORD_CONFIRMATION_MISMATCH'
  static readonly ConfirmPasswordIdenticalError = 'AUTHORIZATION.NEW_AND_OLD_PASSWORD_IDENTICAL'
  static readonly ChangePassword = 'AUTHORIZATION.PASSWORD_CHANGE'
  static readonly ChangePasswordNotice = 'AUTHORIZATION.PASSWORD_CHANGE_NOTICE'
  static readonly ChangePasswordHint = 'AUTHORIZATION.PASSWORD_STRENGTH_SUGGESTION'
  static readonly Password = 'AUTHORIZATION.PASSWORD'
  static readonly PasswordPlaceholder = 'AUTHORIZATION.ENTER_PASSWORD'
  static readonly PasswordStrengthTooWeak = 'AUTHORIZATION.TOO_WEAK'
  static readonly PasswordStrengthWeak = 'AUTHORIZATION.WEAK'
  static readonly PasswordStrengthFair = 'AUTHORIZATION.FAIR'
  static readonly PasswordStrengthGood = 'AUTHORIZATION.GOOD'
  static readonly PasswordStrengthStrong = 'AUTHORIZATION.STRONG'
  static readonly Confirmation = 'AUTHORIZATION.CONFIRMATION'
  static readonly ConfirmationMessage = 'AUTHORIZATION.CONFIRM_PASSWORD_CHANGE'
  static readonly ForgotPassword = 'AUTHORIZATION.PASSWORD_FORGOT'
  static readonly ForgotYourPasswordQuestion = 'AUTHORIZATION.FORGOT_PASSWORD_QUESTION'
  static readonly ForgotPasswordQuestion = 'AUTHORIZATION.FORGOT_PASSWORD'
  static readonly InputUserNameToSendPasswordRestoreCredentials = 'AUTHORIZATION.INPUT_USERNAME_TO_SEND_INSTRUCTIONS'
  static readonly Send = 'AUTHORIZATION.SEND'
  static readonly Login = 'AUTHORIZATION.LOGIN'
  static readonly ChangeLanguage = 'AUTHORIZATION.CHANGE_LANGUAGE'
  static readonly Username = 'AUTHORIZATION.USERNAME'
  static readonly UsernamePlaceholder = 'AUTHORIZATION.ENTER_USERNAME'
  static readonly UsernamePasswordMismatch = 'AUTHORIZATION.USERNAME_PASSWORD_MISMATCH'
  static readonly LegalNotice = 'AUTHORIZATION.LEGAL_NOTICE'
  static readonly Disclaimer = 'AUTHORIZATION.DISCLAIMER'
  static readonly Profile = 'AUTHORIZATION.PROFILE'
  static readonly Cancel = 'AUTHORIZATION.CANCEL'
  static readonly SelectLanguage = 'AUTHORIZATION.SELECT_LANGUAGE'
  static readonly DisagreeTerms = 'AUTHORIZATION.DISAGREEING_TERMS'
  static readonly TermsAndConditionsAgreement = 'AUTHORIZATION.AGREE_TERMS_AND_CONDITIONS'
  static readonly TermsAndConditionsDisagreeWarning = 'AUTHORIZATION.DISAGREE_TERMS_AND_CONDITIONS_WARNING'
  static readonly Done = 'AUTHORIZATION.DONE'
  static readonly UserAccountAmount = 'AUTHORIZATION.USER_ACCOUNTS_AMOUNT'
}

export class ErrorMessagesTranslationKeys {
    static readonly RequiredUserName = 'ERROR_MESSAGES.REQUIRED.USERNAME'
    static readonly RequiredPassword = 'ERROR_MESSAGES.REQUIRED.PASSWORD'
    static readonly RequiredWard = 'ERROR_MESSAGES.REQUIRED.WARD'
    static readonly RequiredProfessionalCategory = 'ERROR_MESSAGES.REQUIRED.PROFESSIONAL_CATEGORY'
    static readonly RequiredProfessionalSubCategory = 'ERROR_MESSAGES.REQUIRED.PROFESSIONAL_SUB_CATEGORY'
    static readonly SomethingWentWrong = 'ERROR_MESSAGES.UNKNOWN'
    static readonly ErrUpdatingPassword = 'AUTHORIZATION.OLD_PASSWORD_INCORRECT_1'
    static readonly NoWardIsConfigured = 'OBSERVATION.MISSING_CONFIG.WARD_FOR_INSTITUTION'
    static readonly NoSubCategoryIsConfigured = 'OBSERVATION.MISSING_CONFIG.SUBCATEGORY_FOR_PROFESSIONAL_CATEGORY'
    static readonly UnableToEdit = 'OBSERVATION.EDIT_REQUIRES_PERFORMED_OBSERVATION'
    static readonly CombinationOfCategroyIsAlreadySelected = 'OBSERVATION.SUB_CATEGORY_ALREADY_ADDED_TO_CATEGORY'
    static readonly NoMomentOrActionSelected = 'OBSERVATION.SAVING_OBSERVATION_REQUIRES_SELECTED_MOMENT_OR_ACTION'
    static readonly SelectMomentFirstThenAction = 'OBSERVATION.INSTRUCTION_HOW_SELECT_ACTION_1'
    static readonly ActionIsNotSelected = 'OBSERVATION.SAVING_OBSERVATION_REQUIRES_SELECTED_ACTION'
    static readonly CheckInternet = 'LAYOUT_MODULE.WAIT_UNTIL_SYNC_COMPLETED'
    static readonly ConnectInternet = 'OBSERVATION.HINT_CONNECT_AND_SYNC'
    static readonly NoInternetConnection = 'AUTHORIZATION.CHECK_INTERNET_CONNECTION'
    static readonly InvalidCredentials = 'BACKEND_SERVICES.INVALID_CREDENTIALS'
    static readonly UnableToVerifyPassword = 'AUTHORIZATION.UNABLE_TO_VERIFY_PASSWORD'
    static readonly ProfileNotUpdated = 'AUTHORIZATION.PROFILE_INFORMATION_NOT_UPDATED'
    static readonly AdmitedUserName = 'ERROR_MESSAGES.USERNAME.ADMITED'
    static readonly AdmitedUserNameLetters = 'ERROR_MESSAGES.USERNAME.LETTERS'
    static readonly AdmitedUserNameNumbers = 'ERROR_MESSAGES.USERNAME.NUMBERS'
    static readonly AdmitedUserNameSpecial = 'ERROR_MESSAGES.USERNAME.SPECIAL'
    static readonly ConsumptionDataMissing = 'ERROR_MESSAGES.CONSUMPTION.MISSING_DATA'
    static readonly ObservationWentWrong = 'ERROR_MESSAGES.UNKNOWN_OBSERVATION'
    static readonly ConfirmUnlinkWebkess = 'ERROR_MESSAGES.CONFIRMATION.UNLINK.WEBKESS'
}

export class LayoutModuleTranslationKeys {
  static readonly Observe = 'LAYOUT_MODULE.OBSERVE'
  static readonly ChangePassword = 'LAYOUT_MODULE.CHANGE_PASSWORD'
  static readonly MyQuotas = 'LAYOUT_MODULE.MY_QUOTAS'
  static readonly Edit = 'LAYOUT_MODULE.EDIT'
  static readonly UpdateAppAlertMessageCritical = "LAYOUT_MODULE.UPDATE_APP_ALERT_MESSAGE_CRITICAL";
  static readonly UpdateAppAlertMessageOptional = "LAYOUT_MODULE.UPDATE_APP_ALERT_MESSAGE_OPTIONAL";
  static readonly UpdateAppAlertTitle = "LAYOUT_MODULE.UPDATE_APP_ALERT_TITLE";
  static readonly HeaderTitle = 'LAYOUT_MODULE.HEADER_TITLE'
}

export class DashboardTranslationKeys {
  static readonly Dashboard = 'LAYOUT_MODULE.DASHBOARD'
  static readonly Countries = 'DASHBOARD.COUNTRIES'
  static readonly All = 'DASHBOARD.ALL'
  static readonly Insititutions = 'Institutions'
  static readonly ThirtyDays = 'DASHBOARD.LAST_30_DAYS'
  static readonly FifteenDays = 'DASHBOARD.LAST_15_DAYS'
  static readonly WeekDays = 'DASHBOARD.LAST_7_DAYS'
  static readonly Today = 'DASHBOARD.TODAY'
  static readonly TotalConsumption = 'DASHBOARD.TOTAL_CONSUMPTION'
  static readonly inLiters = 'CONSUMPTION.AMOUNT.IN_LITERS'
  static readonly TotalObservation = 'DASHBOARD.TOTAL_OBSERVATION'
  static readonly FiveMoments = 'DASHBOARD.FIVE_MOMENTS'
  static readonly OverallCompliance = 'DASHBOARD.OVERALL_COMPLIANCE'
  static readonly Compliance = 'DASHBOARD.COMPLIANCE'
  static readonly NoDataFound = 'EVALUATION.NO_DATA_FOUND'
  static readonly Quotas = 'CONFIGURE.QUOTAS'
  static readonly Progress = 'DASHBOARD.PROGRESS'
  static readonly Opportunities = 'DASHBOARD.OPPORTUNITIES'
  static readonly NoQuotasAssigned = 'DASHBOARD.NO_QUOTAS_ASSIGNED'
  static readonly Change = 'AUTHORIZATION.CHANGE' //EVALUATION.CHANGE?
  static readonly PositiveCompliance = 'DASHBOARD.POSITIVE_COMPLIANCE'
  static readonly NegativeCompliance = 'DASHBOARD.NEGATIVE_COMPLIANCE'
  static readonly SelectCountry = 'SOP_MANAGEMENT.SELECT_COUNTRY'
  static readonly SelectInsititution = 'SOP_MANAGEMENT.SELECT_INSTITUTION'
  static readonly SelectDepartment = 'SOP_OBSERVATION.SELECT.DEPARTMENT'
  static readonly Planned = 'CONFIGURE.SCHEDULED'
  static readonly ComplianceOf = 'DASHBOARD.COMPLIANCE_OF'
  static readonly Pullrefresh = 'GENERAL.PULL_TO_REFRESH'
  static readonly Refreshing = 'GENERAL.REFRESHING'
  static readonly GeneralOf = 'GENERAL.OF'

}

export class ObservationTranslationKeys {
  static readonly Protocol = 'OBSERVATION.PROTOCOL'
  static readonly Ventilation1 = 'OBSERVATION.VENTILATION_1'
  static readonly Ventilation2 = 'OBSERVATION.VENTILATION_2'
  static readonly PreparationOfIVMedication = 'OBSERVATION.PREPARATION_IV_MEDICATION_1'
  static readonly ManipulationIVAccesses = 'OBSERVATION.MANIPULATION_IV_OR_IA_ACCESSES_1'
  static readonly ChangeOfDressing = 'OBSERVATION.CHANGE_DRESSING_OR_MANIPULATION_DRAINAGE_1'
  static readonly Puntures = 'OBSERVATION.PUNCTURES_OR_INSERTION_IV_1'
  static readonly ContactMucouseMembranes = 'OBSERVATION.MUCOUSE_MEMBRANES_CONTACT_1'
  static readonly NotSpecified = 'OBSERVATION.NOT_SPECIFIED'
  static readonly BeforeTouching = 'OBSERVATION.BEFORE.TOUCHING_PATIENT'
  static readonly BeforeAseptic = 'OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1'
  static readonly AfterBodyFluidExposure = 'OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK'
  static readonly AfterTouchingAPatient = 'OBSERVATION.AFTER.TOUCHING_PATIENT'
  static readonly AfterTouchingPatientSurroundings = 'OBSERVATION.AFTER.TOUCHING_SURROUNDINGS'
  static readonly CloseUnsavedForm = 'OBSERVATION.NOTIFICATION_LEAVE_UNSAVED.OBSERVATION'
  static readonly ConfirmClose = 'OBSERVATION.CONFIRM.CLOSE'
  static readonly QuickComment = 'OBSERVATION.QUICK_COMMENT'
  static readonly SelectWardAndCategory = 'OBSERVATION.SELECT_WARD_AND_PROFESSIONAL_CATEGORY_TO_START_SESSION'
  static readonly SelectProfessionalCategory = 'OBSERVATION.SELECT_PROFESSIONAL_CATEGORY'
  static readonly StartSession = 'OBSERVATION.START_SESSION'
  static readonly UnsavedNotification = 'OBSERVATION.NOTIFICATION_LEAVE_UNSAVED.OBSERVATION'
  static readonly UnsavedEndSessionNotification = 'OBSERVATION.NOTIFICATION_LEAVE_UNSAVED.OBSERVATION_AND_END_SESSION'
  static readonly ConfirmEndSession = 'OBSERVATION.CONFIRM.END_SESSION'
  static readonly NoObservationForSession = 'OBSERVATION.NO_OBSERVATION_MADE_FOR_SESSION'
  static readonly Congratulations = 'OBSERVATION.CONGRATULATIONS'
  static readonly UnsavedNewCategoryNotification = 'OBSERVATION.NOTIFICATION_LEAVE_UNSAVED.OBSERVATION_AND_ADD_NEW_CATEGORY'
  static readonly Day = 'OBSERVATION.DAY'
  static readonly Days = 'OBSERVATION.DAYS'
  static readonly DayLeft = 'OBSERVATION.DAY_LEFT'
  static readonly DaysLeft = 'OBSERVATION.DAYS_LEFT'
  static readonly EndSession = 'OBSERVATION.END_SESSION'
  static readonly AddSession = 'OBSERVATION.ADD_SESSION'
  static readonly AddOccupation = 'OBSERVATION.ADD_OCCUPATION'
  static readonly AddCategory = 'OBSERVATION.ADD_CATEGORY'
  static readonly SessionID = 'OBSERVATION.SESSION_ID'
  static readonly ConfirmContinueSession = 'OBSERVATION.CONFIRM.CONTINUE_SESSION'
  static readonly ObservationCount = 'OBSERVATION.COMPLETED_OBSERVATION'
  static readonly ObservationNotcompletedCount = 'OBSERVATION.NOT_COMPLETED_OBSERVATION'
  static readonly AddNewProfessionalCategory = 'OBSERVATION.ADD_NEW_PROFESSIONAL_CATEGORY'
  static readonly TimeAlert = 'OBSERVATION.TIME_ALERT'
  static readonly IdleNotification = 'OBSERVATION.IDLE_NOTIFICATION'
  static readonly SaveObservationAndContinue = 'OBSERVATION.SAVE_OBSERVATION_AND_CONTINUE'
  static readonly AutoSignOutWarning = 'OBSERVATION.AUTO_SIGN_OUT_WARNING'
  static readonly Yesterday = 'OBSERVATION.YESTERDAY'
  static readonly FailedToGetObservedSession = 'OBSERVATION.FAILED.GET_OBSERVED_SESSION'
  static readonly Offline = 'OBSERVATION.OFFLINE'
  static readonly ErrorFetchingSessionDetail = 'OBSERVATION.ERROR_FETCHING_SESSION_DETAIL'
  static readonly ObservedAt = 'OBSERVATION.OBSERVED_AT'
  static readonly FailedToGetQuotas = 'OBSERVATION.FAILED.GET_QUOTAS'
  static readonly Writecomments = 'SOP_OBSERVATION.WRITE_COMMENTS'
  static readonly Handrub = 'OBSERVATION.HANDRUB'
  static readonly Handwash = 'OBSERVATION.HANDWASH'
  static readonly Missed = 'OBSERVATION.MISSED'
  static readonly Gloves = 'OBSERVATION.GLOVES'
  static readonly Next = 'OBSERVATION.NEXT'
  static readonly Save = 'AUTHORIZATION.SAVE'
  static readonly Update = 'SOP_MANAGEMENT.UPDATE'
  static readonly SelectMoments = 'OBSERVATION.SELECT_MOMENTS'
  static readonly SelectActions = 'OBSERVATION.SELECT_ACTIONS'
  static readonly ConfirmDeleteObservation = 'OBSERVATION.CONFIRMATION.DELETE_OBSERVATION'
  static readonly StillWantExit = "OBSERVATION.CONFIRM.STILL_WANT_TO_EXIT";
  static readonly EndObservationExit = "OBSERVATION.END_OBSERVATION_EXIT";
  static readonly ContinueObserving = "OBSERVATION.CONTINUE_OBSERVING";
  static readonly SeeAll = "OBSERVATION.SEE_ALL";
  static readonly History = "OBSERVATION.HISTORY";
  static readonly SavedObservations = "OBSERVATION.SAVED_OBSERVATIONS";
  static readonly UncompletedObservations = "OBSERVATION.UNCOMPLETED_OBERVATIONS";
  static readonly NotSaved = "OBSERVATION.NOT_SAVED_OBSERVATION";
  static readonly NotCompleted = "OBSERVATION.NOT_COMPLETED_OBSERVATION";
  static readonly NotCompletedNotSaved = "OBSERVATION.NOT_COMPLETED_OR_SAVED_OBSERVATION";
  static readonly UnsavedObservations = "OBSERVATION.UNSAVED_OBSERVATIONS";
  static readonly CreatedBy = "OBSERVATION.CREATED_BY";
  static readonly InProgress = "OBSERVATION.IN_PROGRESS";
}

export class ConsumptionTranslationKeys {
  static readonly SelectWard = 'CONSUMPTION.SELECT.WARD'
  static readonly SelectDepartment = 'CONSUMPTION.SELECT.DEPARTMENT'
  static readonly ConsumptionFilterAll = 'CONSUMPTION.FILTER.ALL_INSTITUTION'
  static readonly ConsumptionFilter1Empty = 'CONSUMPTION.FILTER.FILTER1_EMPTY'
  static readonly ConsumptionFilter2Empty = 'CONSUMPTION.FILTER.FILTER2_EMPTY'
  static readonly ConsumptionFilterDifferent = 'CONSUMPTION.FILTER.DIFFERENT'

}

export class SOPObservationTranslationKeys {
  static readonly Back = 'SOP_OBSERVATION.BACK';
  static readonly CheckSteps = 'SOP_OBSERVATION.CHECK_STEPS';
  static readonly Comment = 'SOP_OBSERVATION.COMMENT';
  static readonly Comments = 'SOP_OBSERVATION.COMMENTS';
  static readonly Continue = 'SOP_OBSERVATION.CONTINUE'
  static readonly NoSterility = 'SOP_OBSERVATION.NO_STERILITY';
  static readonly Observation = 'SOP_OBSERVATION.OBSERVATION';
  static readonly ObservationProtocol = 'SOP_OBSERVATION.OBSERVATION_PROTOCOL';
  static readonly ProfessionalCategory = 'SOP_OBSERVATION.PROFESSIONAL_CATEGORY';
  static readonly ProfessionalSubCategory = 'SOP_OBSERVATION.PROFESSIONAL_SUB_CATEGORY';
  static readonly SaveObservation = 'SOP_OBSERVATION.CONFIRMATION.SAVE_OBSERVATION'
  static readonly SelectProfessionalCategory = 'SOP_OBSERVATION.SELECT.PROFESSIONAL_CATEGORY';
  static readonly SelectProfessionalSubCategory = 'SOP_OBSERVATION.SELECT.PROFESSIONAL_SUB_CATEGORY';
  static readonly StartNewObservation = 'SOP_OBSERVATION.START_NEW_OBSERVATION';
  static readonly SuccessfullyAddedSOPObservation = 'SOP_OBSERVATION.SUCCESSFULLY_ADDED_SOP_OBSERVATION';
}

export class ConfigureTranslationKeys {
    static readonly Active = 'CONFIGURE.ACTIVE';
    static readonly AddNewWardDisabled = 'CONFIGURE.ADD_NEW_WARD_DISABLED';
    static readonly AddedWard = 'CONFIGURE.MESSAGE_SUCCESSFULLY.ADDED.WARD';
    static readonly Completed = 'CONFIGURE.COMPLETED';
    static readonly ConsumptionConfMessage = 'CONFIGURE.CONSUMPTION_CONF_MESSAGE';
    static readonly ConsumptionConfNext = 'CONFIGURE.CONSUMPTION_CONF_NEXT';
    static readonly Decline = 'CONFIGURE.DECLINE';
    static readonly Department = 'CONFIGURE.DEPARTMENT';
    static readonly EnterSearchText = 'CONFIGURE.ENTER.SEARCH_TEXT';
    static readonly HaiSettings = 'CONFIGURE.HAI_SETTINGS';
    static readonly NewPeriod = 'CONFIGURE.NEWPERIOD';
    static readonly NextConsumptionSaved = 'CONFIGURE.NEXT_CONSUMPTION_SAVED';
    static readonly NoQuotasForInstitution  = 'CONFIGURE.QUOTAS_NOT_FOUND';
    static readonly PerPage = 'CONFIGURE.PER_PAGE.WARDS';
    static readonly Period = 'CONFIGURE.PERIOD';
    static readonly ProfessionalCategory = 'CONFIGURE.PROFESSIONAL_CATEGORY';
    static readonly ProfessionalSubCategory = 'CONFIGURE.PROFESSIONAL_SUB_CATEGORY';
    static readonly Quota = 'CONFIGURE.QUOTA';
    static readonly SaveComment = 'CONFIGURE.SAVE_COMMENT';
    static readonly Scheduled = 'CONFIGURE.SCHEDULED';
    static readonly TermsAndConditions = 'CONFIGURE.TERMS_CONDITIONS';
    static readonly UnlinkWard = 'CONFIGURE.UNLINKWARD';
    static readonly UpdatedWard = 'CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.WARD';
    static readonly Ward = 'CONFIGURE.WARD';
    static readonly Wards = 'CONFIGURE.WARDS';
}

export class LabelTranslationKeys {
  static readonly English = 'LABEL.LANGUAGE.ENGLISH'
  static readonly German = 'LABEL.LANGUAGE.GERMAN'
  static readonly Spanish = 'LABEL.LANGUAGE.SPANISH'
  static readonly French = 'LABEL.LANGUAGE.FRENCH'
  static readonly Italian = 'LABEL.LANGUAGE.ITALIAN'
  static readonly Dutch = 'LABEL.LANGUAGE.DUTCH'
  static readonly Hungarian = 'LABEL.LANGUAGE.HUNGARIAN'
  static readonly Slovakian = 'LABEL.LANGUAGE.SLOVAKIAN'
  static readonly Czeck = 'LABEL.LANGUAGE.CZECK'
  static readonly Catalan = 'LABEL.LANGUAGE.CATALAN'
  static readonly Portuguese = 'LABEL.LANGUAGE.PORTUGUESE'
}

export class InstitutionManagementTranslationKeys {
  static readonly Close = 'INSTITUTION_MANAGEMENT.CLOSE'
  static readonly Confirmation = 'INSTITUTION_MANAGEMENT.CONFIRMATION'
  static readonly Actions = 'INSTITUTION_MANAGEMENT.ACTIONS'
  static readonly Accounts = 'INSTITUTION_MANAGEMENT.ACCOUNTS'
  static readonly SASOP = 'INSTITUTION_MANAGEMENT.SOP.SASOP'
  static readonly CASOP = 'INSTITUTION_MANAGEMENT.SOP.CASOP'
  static readonly SelectSOP = 'INSTITUTION_MANAGEMENT.SELECT.SOP'
  static readonly SelectAll = 'INSTITUTION_MANAGEMENT.SELECT_ALL'
  static readonly Search = 'INSTITUTION_MANAGEMENT.SEARCH'
  static readonly Institutions = 'INSTITUTION_MANAGEMENT.INSTITUTIONS'


}

export class SOPManagementTranslationKeys {
  static readonly AcceptTerms = 'SOP_MANAGEMENT.ACCEPT_TERMS'
  static readonly SOPTrlUpdateError = 'SOP_MANAGEMENT.UPDATE_TRL_ERROR'
  static readonly SOPTrlUpdateNoConnection = 'SOP_MANAGEMENT.UPDATE_TRL_ERROR_NO_CONNECTION'
  static readonly SOPTrlUpdateLimitIntent = 'SOP_MANAGEMENT.UPDATE_TRL_ERROR_INTENT_LIMIT'
  static readonly Template = 'SOP_MANAGEMENT.TEMPLATE'
}

export class SuccessMessagesTranslationKeys {
  static readonly ProfileUpdated = 'AUTHORIZATION.PROFILE_INFORMATION_UPDATED'
  static readonly PasswordSentToMail = 'AUTHORIZATION.RESET_PASSWORD_INSTRUCTION_MAIL'
  static readonly PasswordUpdated = 'AUTHORIZATION.PASSWORD_UPDATED_SUCCESS_1'
  // ProfileImageUpdated = 'Profile image updated successfully',
  static readonly ObservationSessionCreatedSuccessfully = 'OBSERVATION.MESSAGE_SUCCESSFULLY.OBSERVATION.SESSION_CREATED'
  static readonly ObservationCreatedSuccessfully = 'OBSERVATION.MESSAGE_SUCCESSFULLY.OBSERVATION.CREATED'
  static readonly ObservationUpdated = 'OBSERVATION.MESSAGE_SUCCESSFULLY.OBSERVATION.UPDATED'
  static readonly QuotaCompleted = 'OBSERVATION.MESSAGE_SUCCESSFULLY.CONGRATULATIONS_COMPLETED_ASSIGNED_QUOTA'
  static readonly IndividualObservationSynced = 'OBSERVATION.MESSAGE_SUCCESSFULLY.OBSERVATION.SYNCED'
  static readonly SyncedSuccessfully = "OBSERVATION.MESSAGE_SUCCESSFULLY.SYNCED_SUCCESSFULLY"

}
export class WarningMessagesTranslationKeys {
  static readonly NoImageSelected = 'AUTHORIZATION.NO_IMAGE_SELECTED'
  static readonly UsernameNotFound = 'BACKEND_SERVICES.NOT_FOUND.USERNAME'
}

export class ProfileDetailsTranslationKeys {
  static readonly Name = 'AUTHORIZATION.NAME'
  static readonly Email = 'AUTHORIZATION.E_MAIL'
  static readonly EnterYourName = 'AUTHORIZATION.ENTER_NAME_2'
  static readonly NameRequired = 'ERROR_MESSAGES.REQUIRED.NAME'
  static readonly EnterYourMail = 'AUTHORIZATION.ENTER_EMAIL_ID'
  static readonly MailRequired = 'AUTHORIZATION.EMAIL_ID_REQUIRED'
  static readonly Role = 'USER_MANAGEMENT.ROLE'
  static readonly Username = 'AUTHORIZATION.USERNAME'
  static readonly InstitutionName = 'AUTHORIZATION.INSTITUTION_NAME'
  static readonly ValidateUser = 'AUTHORIZATION.VALIDATE_USER'
  static readonly ValidateUserMessage = 'AUTHORIZATION.PASSWORD_REQUIRED_TO_MODIFY_PROFILE_DETAILS'
  static readonly EnterPassword = 'AUTHORIZATION.ENTER_PASSWORD'
  static readonly Yes = 'BUTTON.YES'
  static readonly No = 'BUTTON.NO'
}

export class UserProfileTranslationKeys {
  static readonly SelectInsititutions = 'CONFIGURE.SELECT_INSTITUTION'
  static readonly Signout = 'AUTHORIZATION.SIGN_OUT'
  static readonly ChangePassword = 'AUTHORIZATION.PASSWORD_CHANGE'
  static readonly Profile = 'AUTHORIZATION.PROFILE'
  static readonly ProfileDetails = 'AUTHORIZATION.PROFILE_DETAILS'
  static readonly TermsAndConditions = 'CONFIGURE.TERMS_CONDITIONS'
}


export class WebkessTranslationsKeys {
    static readonly SelectConsumption = 'WEBKESS_INTEGRATION.SELECT_CONSUMPTION_OR_OBSERVATIONS'
    static readonly ChooseConsumption = 'WEBKESS_INTEGRATION.CHOOSE_CONSUMPTION'
    static readonly SentRequest = 'WEBKESS_INTEGRATION.SUCCESSFULLY.SENT_REQUEST_TO_COUNTRY_ADMIN'
    static readonly EstablishedConnection = 'WEBKESS_INTEGRATION.SUCCESSFULLY.ESTABLISHED_CONNECTION'
    static readonly EnterValidSettings = 'WEBKESS_INTEGRATION.WEBKESS.ENTER_VALID_SETTINGS'
    static readonly EnterValidKhcode = 'WEBKESS_INTEGRATION.WEBKESS.ENTER_VALID_KHCODE'
    static readonly KhcodeDuplicated = 'WEBKESS_INTEGRATION.WEBKESS.KHCODE_DUPLICATED'
    static readonly ErrorTestingConnection = 'WEBKESS_INTEGRATION.WEBKESS.ERROR_TEST_CONNECTION'
    static readonly ImportWard = 'WEBKESS_INTEGRATION.IMPORT.WARD'
    static readonly ImportDept = 'WEBKESS_INTEGRATION.IMPORT.DEPARTAMENT'
    static readonly ExistingMapped = 'WEBKESS_INTEGRATION.IMPORT.EXISTING_MAPPED'
    static readonly UpdatesAvailable = 'WEBKESS_INTEGRATION.NO_WARD_UPDATES_AVAILABLE'
    static readonly DownloadedWards = 'WEBKESS_INTEGRATION.SUCCESSFULLY.DOWNLOADED_WARDS'
    static readonly ExportEndDate = 'WEBKESS_INTEGRATION.EXPORT.END_DATE'
    static readonly PeriodTooLong = 'WEBKESS_INTEGRATION.PERIOD_TOO_LONG'
    static readonly AssignDept = 'WEBKESS_INTEGRATION.ASSIGN_APPROPRIATE_DEPARTMENT'
    static readonly ExportInitiated = 'WEBKESS_INTEGRATION.EXPORT_INITIATED'
    static readonly OverlappedPeriod = 'WEBKESS_INTEGRATION.OVERLAPPED_PERIOD'
    static readonly WebKessWard = 'WEBKESS_INTEGRATION.WEBKESS.WARD'
    static readonly DownloadWards = 'WEBKESS_INTEGRATION.DOWNLOAD_WARDS'
    static readonly DownloadWardsDisabled = 'WEBKESS_INTEGRATION.DOWNLOAD_WARDS_DISABLED'
    static readonly ImportRunning = 'WEBKESS_INTEGRATION.EXPORT.IMPORT_RUNNING'
    static readonly NoObservations = 'WEBKESS_INTEGRATION.EXPORT.NO_OBSERVATIONS'
    static readonly NoConsumptions = 'WEBKESS_INTEGRATION.EXPORT.NO_CONSUMPTIONS'
    static readonly UploadFinished = 'WEBKESS_INTEGRATION.EXPORT.UPLOAD_FINISHED'
    static readonly UploadFinishedSentToWebkess = 'WEBKESS_INTEGRATION.EXPORT.UPLOAD_FINISHED_SENT_TO_WEBKESS'
    static readonly WaitUpload = 'WEBKESS_INTEGRATION.EXPORT.WAIT_UPLOAD'
    static readonly UploadRunning = 'WEBKESS_INTEGRATION.EXPORT.UPLOAD_RUNNING'
    static readonly DeletePeriod = 'WEBKESS_INTEGRATION.DELETE_PERIOD'
    static readonly IntervalDeletion = 'WEBKESS_INTEGRATION.INTERVAL_DELETION'
    static readonly DeletionInProgress = 'WEBKESS_INTEGRATION.INTERVAL_DELETION_IN_PROGRESS'
    static readonly DeletionConformation = 'WEBKESS_INTEGRATION.INTERVAL_DELETION_CONFIRMATION'
    static readonly DeletionPeriodCancel = 'WEBKESS_INTEGRATION.DELETE_PERIOD_CANCEL'
    static readonly DeletePeriodInitiated = 'WEBKESS_INTEGRATION.DELETE_PERIOD_INITIATED'
    static readonly DeletionPeriod = 'WEBKESS_INTEGRATION.DELETE_PERIOD_ERROR'
    static readonly DeletePeriodCompleted = 'WEBKESS_INTEGRATION.DELETE_PERIOD_COMPLETED'
    static readonly DeletionConfirmationHeader = 'WEBKESS_INTEGRATION.INTERVAL_DELETION_CONFIRMATION_HEADER'
    static readonly SaveCredentials = 'WEBKESS_INTEGRATION.SAVE_CREDENTIALS_ERROR'
    static readonly ImportAction = 'WEBKESS_INTEGRATION.IMPORT.ACTION'
    static readonly ImportParameter = 'WEBKESS_INTEGRATION.IMPORT.PARAMETER'
    
    static readonly WebkessWard = 'WEBKESS_INTEGRATION.WARDS'
    static readonly WebkessAction = 'WEBKESS_INTEGRATION.ACTION'
    static readonly WebkessSelectOption = 'WEBKESS_INTEGRATION.SELECT_OPTION'
    static readonly WebkessSelectWard = 'WEBKESS_INTEGRATION.SELECT_WARD'
    static readonly WebkessSelectDepartment = 'WEBKESS_INTEGRATION.SELECT_DEPARTMENT'
    static readonly WebkessActionImport = 'WEBKESS_INTEGRATION.ACTIONS.IMPORT'
    static readonly WebkessActionMatch = 'WEBKESS_INTEGRATION.ACTIONS.MATCH'
    static readonly WebkessActionIgnore = 'WEBKESS_INTEGRATION.ACTIONS.IGNORE'

    static readonly WebkessNoWardsToUpdate = 'WEBKESS_INTEGRATION.NO_WARDS_TO_UPDATE'
    static readonly WebkessCheckParameters = 'WEBKESS_INTEGRATION.CHECK_PARAMETERS'
    static readonly WebkessDuplicateWards = 'WEBKESS_INTEGRATION.DUPLICATE_WARD_NAME'
}


export class ObserveIndividualDataExportColumnsTranslationKeys {
  static readonly AfterBodyFluidExposure = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.AFTER_BODY_FLUID_EXPOSURE'
  static readonly AfterPatientContact = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.AFTER_PATIENT_CONTACT'
  static readonly AfterPatientSurroundings = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.AFTER_PATIENT_SURROUNDINGS'
  static readonly AmountPeopleObserved = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.AMOUNT_OF_PEOPLE_OBSERVED'
  static readonly AsepticTaskAssignment = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.ASEPTIC_TASKS_ASSIGNMENT'
  static readonly BeforeAsepticTask = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.BEFORE_ASEPTIC_TASK'
  static readonly BeforePatientContact = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.BEFORE_PATIENT_CONTACT'
  static readonly Comment = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.COMMENT'
  static readonly Compliant = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.COMPLIANT'
  static readonly Departments = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.DEPARTMENTS'
  static readonly Description = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.DESCRIPTION'
  static readonly Gloves = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.GLOVES'
  static readonly HandRub = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.HAND_RUB'
  static readonly HandWash = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.HAND_WASH'
  static readonly Institution = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.INSTITUTION'
  static readonly Missed = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.MISSED'
  static readonly ObservationID = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.OBSERVATION_ID'
  static readonly ProfessionalCategory = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.PROFESSIONAL_CATEGORY'
  static readonly ProfessionalSubcategory = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.PROFESSIONAL_SUBCATEGORY'
  static readonly Time = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.TIME'
  static readonly Wards = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_COLUMNS.WARDS'
}

export class EvaluationTranslationsKeys {
  static readonly EvalCompliance1 = 'EVALUATION.FILTER_1.COMPLIANCE'
  static readonly EvalOportuinities1 = 'EVALUATION.FILTER_1.OPORTUNITIES'
  static readonly EvalActions1 = 'EVALUATION.FILTER_1.ACTIONS'
  static readonly EvalCompliance2 = 'EVALUATION.FILTER_2.COMPLIANCE'
  static readonly EvalOportuinities2 = 'EVALUATION.FILTER_2.OPORTUNITIES'
  static readonly EvalActions2 = 'EVALUATION.FILTER_2.ACTIONS'
  static readonly IndividualDataObservationDetailsExcelExport = 'EVALUATION.OBSERVE_INDIVIDUAL_DATA.OBSERVATION_DETAILS_EXCEL_EXPORT'
  static readonly Evaluate = 'EVALUATION.EVALUATE'
  static readonly Compare = 'EVALUATION.COMPARE'
  static readonly AddFilter = 'EVALUATION.ADD_FILTER'
  static readonly ObserveIndividualDataExportColumns: typeof ObserveIndividualDataExportColumnsTranslationKeys = ObserveIndividualDataExportColumnsTranslationKeys
}

export class TranslationKeys {
  static readonly Authorization: typeof AuthorizationTranslationKeys = AuthorizationTranslationKeys
  static readonly Button: typeof ButtonTranslationKeys = ButtonTranslationKeys
  static readonly Configure: typeof ConfigureTranslationKeys = ConfigureTranslationKeys
  static readonly Consumption: typeof ConsumptionTranslationKeys = ConsumptionTranslationKeys
  static readonly Dashboard: typeof DashboardTranslationKeys = DashboardTranslationKeys
  static readonly ErrorMessages: typeof ErrorMessagesTranslationKeys = ErrorMessagesTranslationKeys
  static readonly InstitutionManagement: typeof InstitutionManagementTranslationKeys = InstitutionManagementTranslationKeys
  static readonly Label: typeof LabelTranslationKeys = LabelTranslationKeys
  static readonly LayoutModule: typeof LayoutModuleTranslationKeys = LayoutModuleTranslationKeys
  static readonly Observation: typeof ObservationTranslationKeys = ObservationTranslationKeys
  static readonly SOPManagement: typeof SOPManagementTranslationKeys = SOPManagementTranslationKeys
  static readonly SOPObservation: typeof SOPObservationTranslationKeys = SOPObservationTranslationKeys
  static readonly SuccessMessages: typeof SuccessMessagesTranslationKeys = SuccessMessagesTranslationKeys
  static readonly WarningMessages: typeof WarningMessagesTranslationKeys = WarningMessagesTranslationKeys
  static readonly ProfileDetails: typeof ProfileDetailsTranslationKeys = ProfileDetailsTranslationKeys
  static readonly UserProfiles: typeof UserProfileTranslationKeys = UserProfileTranslationKeys
  static readonly Webkess: typeof WebkessTranslationsKeys = WebkessTranslationsKeys
  static readonly Evaluation: typeof EvaluationTranslationsKeys = EvaluationTranslationsKeys

}
